const qrCodeEnrollmentTranslations = {
  en: {
    invalidTitle: "Invalid QR Link",
    invalidSubtitle: "QR enrollment link is missing or invalid.",
    pageTitle: "QR Enrollment",
    subtitle: "Fill details to enroll and pay admission fee.",
    submitBtn: "Submit & Pay Admission Fee",
  },
  pa: {
    invalidTitle: "QR ਲਿੰਕ ਗਲਤ ਹੈ",
    invalidSubtitle: "QR ਦਾਖਲਾ ਲਿੰਕ ਗੁੰਮ ਜਾਂ ਗਲਤ ਹੈ।",
    pageTitle: "QR ਦਾਖਲਾ",
    subtitle: "ਦਾਖਲਾ ਅਤੇ ਫੀਸ ਭਰਨ ਲਈ ਵੇਰਵੇ ਭਰੋ।",
    submitBtn: "ਦਾਖਲਾ ਭੇਜੋ ਅਤੇ ਫੀਸ ਭਰੋ",
  },
};

export default qrCodeEnrollmentTranslations;
